/** Stable role identities. Role names are display labels only. */
export const ROLE_ADMIN = 1;
export const ROLE_CREATOR = 2;
export const ROLE_PLAYER = 3;

export const isAdminRole = (roleId) => roleId === ROLE_ADMIN;
export const isCreatorRole = (roleId) => roleId === ROLE_CREATOR;
export const isPlayerRole = (roleId) => roleId === ROLE_PLAYER;
export const canCreateInSpace = (roleId) =>
  roleId === ROLE_ADMIN || roleId === ROLE_CREATOR;
